/** Shopify CDN: Minification failed

Line 28:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 46:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 60:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:39 Expected "}" but found "that"

**/
// One SERVICES registry entry per service, same "data + template" split as
// PROJECTS/project-template.js. Only Residential is populated for now; the
// other four slugs get filled in once this template is confirmed.
//
// Copy for `acts` (bullets + closing line) and `subservices` (subtitle +
// paragraph + tagline) is adapted from the studio's previous live site
// (sixthsensestudio.co/residential-interior-design) — that page had
// substantially more copy than the first build-spec draft used here
// (single-sentence acts, one-line hooks). Adapted into this site's
// tighter voice rather than used verbatim, but keeps the added substance:
// the bulleted specifics per act, and the subtitle+paragraph per
// sub-service instead of just a hook line.
// Every service's slug + nav name, independent of which are actually
// built yet — drives the sitewide Services nav dropdown (nav-dropdown.js)
// and the homepage's "What We Do" row links (homepage.js). Only
// "residential" has a full SERVICES entry so far; the other 4 links go
// live automatically as each one gets built, no template change needed.
const SERVICE_INDEX = [
  { slug: "residential", name: "Residential" },
  { slug: "virtual-design", name: "Virtual Design" },
  { slug: "commercial", name: "Commercial" },
  { slug: "investment-rental", name: "Investment & Rental" },
  { slug: "new-development", name: "New Development" },
];

// Shared Process-beat media, originally built for Virtual Design's own 3
// Acts, then reused verbatim in the same 3 positions (Act 1 / Act 2 / Act 3)
// on Commercial, Investment & Rental, and New Development per explicit
// request — the intent was these 4 pages' Process sections match each
// other exactly, one photo per act, not this same trio repeated 3x within
// a single page. (An earlier pass here misread that request as "all 3 Acts
// on each page become the postcard stack" — corrected.) Each service page
// keeps its own copies of every file referenced below
// (assets/images/services/{slug}/), same per-page-folder convention every
// other image on the site follows — nothing here is cross-page-linked.
const PROCESS_ACT1_TALKING = { base: "act-1-talking", widths: [800, 1024], sizes: "(min-width: 900px) 50vw, 100vw", alt: "Elay and Jordan of Sixth Sense Studio mid-consultation, a real candid moment" };
const PROCESS_ACT3_LIVINGROOM = { base: "act-3-livingroom", widths: [900, 1500], sizes: "(min-width: 900px) 50vw, 100vw", alt: "Client living room, styled seating around a stone fireplace" };
// Act 2's "postcard stack" — 3 real client presentation images (a photoreal
// render, a branded moodboard slide, a white 3D blockout model), rendered
// as a pinned/tilted card cluster instead of a single framed photo (see
// services-template.js's renderActMedia, act.images branch). Reuses the
// homepage's own Process Beat 2 .moodboard-card composition (main.css)
// verbatim — "technique from the homepage" was the original request.
const PROCESS_POSTCARDS = [
  { base: "act-2-render", widths: [700, 1000], sizes: "26vw", ratio: "1594/1080", alt: "Photoreal rendering of a client's finished sitting area", caption: "Design Render — Sitting Area" },
  { base: "act-2-moodboard", widths: [700, 1000], sizes: "26vw", ratio: "1920/1080", alt: "Branded mood board slide for a client sitting area, paint swatch and furnishings", caption: "Mood Board — Sitting Area" },
  { base: "act-2-blockout", widths: [700, 1000], sizes: "22vw", ratio: "1269/663", alt: "White 3D blockout model of a client bedroom layout", caption: "3D Layout — Bedroom" },
];

const SERVICES = {
  "residential": {
    slug: "residential",
    name: "Residential",
    pageTitle: "Residential Interior Design",
    tagline: "Full-service residential design for Tampa Bay homes. Projects begin at $80K.",
    heroImage: { base: "hero", widths: [1600, 2000], sizes: "100vw", alt: "Waterfront living room, soft neutral palette" },
    acts: [
      {
        label: "The First Read",
        body: "Begin with a $199 in-home consultation to define your goals, scope, and next steps.",
        bullets: [
          "Learn how you live, and how you want to feel in your home",
          "Explore your style instincts, spatial needs, and emotional anchors",
          "Review existing architecture and furnishings, and what's worth honoring or evolving",
          "Begin forming the intuitive framework that guides every decision that follows",
        ],
        closing: "We don't just decorate. We interpret. We see what others miss.",
        // A real consultation shot (user-supplied) — even better than the
        // reused lifestyle photo this replaced, since it's the literal
        // moment this act's copy describes, not just thematically close.
        image: { base: "act-1-consult", widths: [476, 953], sizes: "(min-width: 900px) 50vw, 100vw", alt: "In-home consultation, walking a client through the space" },
      },
      {
        label: "The Vision Unfolds",
        body: "Concept, layout, sourcing, and styling, developed in layers and refined with you until every choice feels inevitable.",
        bullets: [
          "A visual concept grounded in your desires and daily rituals",
          "Floor plans and layouts designed for real life, not just photographs",
          "Finishes, furnishings, lighting, and art, chosen with intention",
          "Sourcing tailored to your lifestyle, budget, and moodboard",
          "In-person presentations or digital reviews, your choice",
          "Coordination with trades, contractors, and artisans",
          "Two rounds of refinement, until it feels right",
        ],
        closing: "Design unfolds in layers — each one intentional, each one guided.",
        // Top-down material/finish flat-lay (user-supplied) — swapped in
        // over the master-bedroom moodboard. Portrait-composed like that
        // one (no edge-cropping issue), literal sourcing/selection moment
        // for "Finishes, furnishings, lighting, and art, chosen with
        // intention."
        image: { base: "act-2-materials", widths: [590, 1179], sizes: "(min-width: 900px) 50vw, 100vw", alt: "Flat-lay of material and finish samples: fabric, marble, leather, hardware" },
      },
      {
        label: "The Final Reveal",
        body: "Installation and styling, down to the last detail. You come home to a space that was always meant to be yours.",
        bullets: [
          "A fully realized, tactile, intentional interior",
          "Curated furnishings, custom finishes, layered styling",
          "Installation and walkthrough, for full-service packages",
          "Styling notes and care instructions, so the space stays alive",
        ],
        closing: "It won't just look beautiful. It will feel like home, reimagined.",
        // Final styling in progress (a real studio team photo), not an
        // empty finished room — continues the human thread Acts 1-2 both
        // have (a client consultation, a hand-drawn moodboard) instead of
        // breaking pattern with a static "after" shot. Literally matches
        // this act's own "styling, down to the last detail" bullet.
        // Replaced with a new source photo (same tight arms-over-pillow
        // framing) — already a wide banner shot, so the only prep needed
        // was cropping off the black letterbox bars baked into the file
        // itself, no portrait-to-wide extraction this time.
        image: { base: "act-3-styling", widths: [900, 1700], sizes: "(min-width: 900px) 50vw, 100vw", alt: "Hands arranging a pillow, close on the final styling detail" },
      },
    ],
    subservices: [
      {
        name: "Room by Room Design",
        subtitle: "Best for kitchen and bath renovations, or a single-space transformation.",
        body: "Focused and refined — ideal when you want to elevate one room at a time, whether that's a soulful kitchen redesign, a serene spa-like bath, or a home office that stirs creativity. Even a single room can become a sensory experience, layered with intention and mood.",
        hook: "Sometimes, one room is all it takes to feel the shift.",
        image: { base: "included-1", widths: [1250, 2500], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Hands leafing through coffee table books, styled vignette" },
      },
      {
        name: "Renovation & Remodeling",
        subtitle: "Reimagining what already exists, with soul and structure.",
        body: "For clients ready to transform their current home into a sanctuary that reflects where they are now. From structural changes to aesthetic elevation, we guide the entire process — layout, material selections, custom finishes, and contractor collaboration.",
        hook: "We don't just renovate. We reinterpret.",
        image: { base: "included-2", widths: [1250, 2500], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Table styling in progress, woven wall baskets behind" },
      },
      {
        name: "Furnishings & Styling",
        subtitle: "The soul of the space lives in the layers.",
        body: "For a fully styled home without construction — bespoke furnishings, curated decor, textured finishes, and the tactile moments that bring a room to life.",
        hook: "Where softness meets structure.",
        image: { base: "included-3", widths: [277, 554], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Styling a ceramic vase with dried florals on a marble table" },
      },
      {
        name: "Lighting Design",
        subtitle: "Mood, function, and focus, crafted in glow.",
        body: "Lighting plans that shape how a space feels and flows — sculptural fixtures, task lighting, and layered ambience, bringing intention to every shadow and every shimmer.",
        hook: "Because lighting isn't a detail. It's a direction.",
        image: { base: "included-4", widths: [598, 1197], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Sculptural woven pendant light against patterned wallpaper" },
      },
      {
        name: "Color Consultations",
        subtitle: "Emotionally intelligent color stories that shape the way you live.",
        body: "For clients seeking clarity in the midst of indecision. We help define a palette that feels authentic and atmospheric — from paint to finish pairings, translating emotion into color with quiet confidence.",
        hook: "Where intuition meets hue.",
        image: { base: "included-5", widths: [282, 564], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Material and paint palette flat-lay, marble and wood tones" },
      },
      {
        name: "Custom Cabinetry",
        subtitle: "Built-in beauty that works as hard as it looks.",
        body: "Whether kitchen, bath, closet, or media wall, our custom cabinetry is tailored to your lifestyle and spatial needs — seamless, functional, and always refined.",
        hook: "Crafted with precision. Styled with soul.",
        image: { base: "included-6", widths: [368, 736], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Kitchen with green marble island and custom wood cabinetry" },
      },
      {
        name: "Art Procurement",
        subtitle: "Curation that completes the story.",
        body: "We source original, soulful pieces that bring emotion and narrative to your space — balancing texture, scale, and tone to reflect who you are.",
        hook: "Not just decor. Visual memory.",
        image: { base: "included-7", widths: [1250, 2500], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Framed art above a styled reading chair" },
      },
      {
        name: "Space & Room Planning",
        subtitle: "Flow that fits the way you live.",
        body: "Through layout guidance and room planning, we help you make the most of every square foot — enhancing comfort, purpose, and intuitive movement.",
        hook: "A well-designed space doesn't just look right. It feels right.",
        image: { base: "included-8", widths: [367, 735], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Design moodboard displayed on a tablet" },
      },
    ],
    ctaLine: "Reach Out. Feel at Home.",
  },

  // Copy adapted from the studio's old live site
  // (sixthsensestudio.co/virtual-design) — same tighter-voice adaptation
  // residential's copy went through, not used verbatim. Images: hero and
  // "3D Floor Plans" reuse the same 3D render (a real client deliverable,
  // downloaded at full 2500px from the old site — the version already in
  // assets/images/marketing/ is a small 440/660px crop, too small for a
  // hero).
  //
  // Follow-up (same session): Act 1/2/3 and the Mood Boards/Shopping List
  // subservice images replaced again, this time with real client-facing
  // deliverables the user supplied directly (not sourced from the old site
  // or reused marketing photography). Act 1 is a real candid photo of Elay
  // and Jordan (the studio's own team) mid-consultation — cropped 4:5 from
  // a 5184x3456 landscape original, centered (keeps both women and the
  // lamp that anchors the shot). Act 2 is a genuinely different
  // composition from every other act-beat on the site: 3 real client
  // presentation images (a photoreal render, a branded moodboard slide, a
  // white 3D blockout model) as a "postcard stack" — same pinned/tilted
  // .moodboard-card technique the homepage's own Process Beat 2 uses
  // (services-template.js's `images` array branch, see main.css
  // .act-postcards), not the standard single-image act-beat-media slot.
  // Act 3 is a real living room photo, cropped to 21:9 (the site's
  // standing preference for this slot — see .act-beat-3 .act-beat-media,
  // main.css) keeping the fireplace/seating group and trimming mostly
  // empty ceiling. Mood Boards uses a real design presentation slide,
  // center-cropped 4:5 (vertical) from its 1920x1080 landscape original.
  // Shopping List uses a real client-facing shoppable-list screenshot
  // (approve/decline UI, priced line items), top-cropped to 4:5 at its
  // native 1612px width, no upscaling.
  "virtual-design": {
    slug: "virtual-design",
    name: "Virtual Design",
    pageTitle: "Virtual Design",
    tagline: "Curated design, wherever you are.",
    heroImage: { base: "hero", widths: [1600, 2000], sizes: "100vw", alt: "3D rendering of a styled living room, from a real client design package" },
    acts: [
      {
        label: "The First Conversation",
        body: "A 1:1 virtual consultation via video call, wherever you are. This call lays the emotional and practical foundation for the design to unfold.",
        bullets: [
          "Get to know your space and how you want to feel in it",
          "Discuss design goals, layout, color preferences, and your overall vision",
          "Review measurements and inspiration, and any existing elements you'd like to incorporate",
        ],
        closing: "One call, and the direction is already taking shape.",
        image: PROCESS_ACT1_TALKING,
      },
      {
        label: "Design From a Distance",
        body: "Once aligned, we begin shaping your design, a personalized digital plan built entirely around how you live.",
        bullets: [
          "A custom digital mood board reflecting your aesthetic and needs",
          "A personalized 3D floor plan with recommended layout and spatial flow",
          "Curated furnishings, finishes, lighting, and decor, each chosen for beauty and intention",
          "A shopping list with direct links, making sourcing simple and seamless",
          "One round of thoughtful revisions to ensure everything aligns with your vision",
        ],
        closing: "Design unfolds in layers, even from a distance.",
        images: PROCESS_POSTCARDS,
      },
      {
        label: "Your Space, Delivered",
        body: "A cohesive, high-resolution digital design package, so you can bring it all to life on your own time.",
        bullets: [
          "Clickable shopping list with sourced products",
          "Floor plan or spatial layout guide",
          "Styling tips and design notes to help bring everything to life",
        ],
        closing: "An immersive, intuitive space that feels curated and completely you, from anywhere in the world.",
        image: PROCESS_ACT3_LIVINGROOM,
      },
    ],
    subservices: [
      {
        name: "Mood Boards",
        subtitle: "Visual storytelling, before anything is purchased.",
        body: "Our mood boards are a curated glimpse into the emotional direction of your space. Through color palettes, textures, materials, and selected pieces, we help you feel the atmosphere before a single item arrives.",
        hook: "The foundation of your design narrative, intuitive, inspired, and uniquely you.",
        image: { base: "included-1", widths: [700, 864], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Bedroom mood board slide, vertical crop, chandelier and upholstered headboard" },
      },
      {
        name: "Shopping List",
        subtitle: "Style with ease. Curate with confidence.",
        body: "Receive a complete, shoppable list of each hand-selected piece chosen for your space, furniture, lighting, textiles, decor, and more, thoughtfully sourced to reflect your taste, budget, and lifestyle.",
        hook: "Effortless sourcing, piece by intentional piece.",
        image: { base: "included-2", widths: [700, 1612], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Client-facing shoppable list interface, priced line items with approve/decline status" },
      },
      {
        name: "3D Floor Plans",
        subtitle: "Step into your future space, before it's real.",
        body: "Our lifelike 3D renderings let you visually experience the layout, design elements, and energy of your finished space, so every selection feels just right before it's made.",
        hook: "See it clearly. Decide with confidence.",
        image: { base: "included-3", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "3D rendering of a styled living room" },
      },
    ],
    ctaLine: "Reach Out. Feel It From Anywhere.",
  },

  // Copy adapted from sixthsensestudio.co/commercial-design, same
  // tighter-voice adaptation as the other services. Images: the hero and
  // "Single Space Transformations" both reuse the studio's own boutique
  // retail shot (the site's existing marketing image for this service,
  // downloaded larger from the old site — 736x981 native, its own
  // ceiling, no bigger version exists); "Renovation & Reimagining" and
  // "New Development" use real on-topic photos from the old site (a
  // mid-repaint ladder shot, a hard-hat-and-blueprints flat-lay). The 3
  // Process-beat images went through two follow-up passes: first replaced
  // from generic reused marketing photography with real Sixth Sense Studio
  // project photography (JW/AB/AT Residence), then replaced again — per
  // explicit request — with PROCESS_POSTCARDS (the same 3-image "postcard
  // stack" built for Virtual Design's Act 2), reused verbatim across all 3
  // Acts here. See PROCESS_POSTCARDS's own comment above for the full
  // rationale/technique.
  commercial: {
    slug: "commercial",
    name: "Commercial",
    pageTitle: "Commercial Interior Design",
    tagline: "Designed to speak before you do.",
    heroImage: { base: "hero", widths: [1600, 2000], sizes: "100vw", alt: "Boutique retail interior, organic mirror and exposed brick" },
    acts: [
      {
        label: "Where It Starts",
        body: "In our first consultation, virtual or on-site, we explore more than square footage. We explore intention, identity, and impact.",
        bullets: [
          "Learn about your business, brand essence, and how you want people to feel",
          "Review your goals, pain points, and existing layout or architectural limitations",
          "Define the emotional atmosphere your space needs to carry, calm, creativity, clarity, confidence",
        ],
        closing: "We craft a design direction that aligns the unseen with the unforgettable.",
        image: PROCESS_ACT1_TALKING,
      },
      {
        label: "Building the Brand",
        body: "Designing a commercial space isn't just about aesthetics, it's about emotional branding, flow, and function.",
        bullets: [
          "Mood boards and concept visuals that capture your brand's essence",
          "Layout planning and spatial strategy for customer experience, workflow, or display",
          "Finish and material palettes with both beauty and durability in mind",
          "Custom sourcing of lighting, furniture, signage, and design elements",
          "Collaboration with an architect, builder, or contractor, if applicable",
          "One round of thoughtful revisions to refine and perfect the vision",
        ],
        closing: "Every choice in service of how the space works, and how it feels to be in it.",
        images: PROCESS_POSTCARDS,
      },
      {
        label: "Ready to Open",
        body: "A fully-developed design concept, ready for the people who'll actually move through it.",
        bullets: [
          "A complete moodboard and materials list",
          "Floor plan layouts or zoning suggestions",
          "Product sourcing and purchase recommendations",
          "Styling notes for brand continuity and ambiance",
        ],
        closing: "A place where your clients, customers, or team don't just walk in, they feel it.",
        image: PROCESS_ACT3_LIVINGROOM,
      },
    ],
    subservices: [
      {
        name: "Single Space Transformations",
        subtitle: "Best for storefronts, studios, or curated client-facing spaces.",
        body: "One room can tell a story. This service is for boutique businesses and creative spaces looking to refine a single key area, like a serene wellness studio, a high-touch reception zone, or a curated retail moment that leaves an impression.",
        hook: "Let your space speak volumes.",
        image: { base: "included-1", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Boutique retail interior, organic mirror and exposed brick" },
      },
      {
        name: "Renovation & Reimagining",
        subtitle: "Breathe new soul into an existing space.",
        body: "Perfect for brands in transition, growing teams, or legacy businesses ready to modernize without losing their essence. This service guides you through layout enhancements, aesthetic rebranding, material selection, and contractor collaboration.",
        hook: "We don't just update. We translate your essence into space.",
        image: { base: "included-2", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Mid-renovation, ladder and paint roller against a freshly painted wall" },
      },
      {
        name: "New Development & Concept-to-Completion",
        subtitle: "Brand environments built from blueprint to final install.",
        body: "For founders and developers launching new concepts or building fresh footprints from the ground up. This is our most immersive offering, designing not just the space, but the sensory experience.",
        hook: "Where the brand becomes a place, and the place becomes a feeling.",
        image: { base: "included-3", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Hard hat and blueprints, planning a new commercial build" },
      },
    ],
    ctaLine: "Reach Out. Feel the Brand.",
  },

  // The old site (sixthsensestudio.co/rental-property-design) has no
  // 3-act process section like the other services — just 4 flat
  // offerings, no "Where It Begins"/"Our Intuitive Process"/"The Final
  // Unfolding" narrative. Acts here are written fresh, in the same voice
  // and shape as the other 4 services, adapted for short-term/mid-term
  // rental specifics; the 4 offerings became the subservices list
  // unchanged. Subservice images: 4 real high-res photos from the old
  // site (a poolside styling shot, a welcoming entryway, poolside
  // furnishings detail, a full property exterior). Act images were
  // originally these same 4 photos doubled up (each also reused once for
  // its matching act) — replaced per explicit follow-up with
  // PROCESS_POSTCARDS (the same 3-image "postcard stack" built for Virtual
  // Design's Act 2), reused verbatim across all 3 Acts here — see
  // PROCESS_POSTCARDS's own comment above.
  "investment-rental": {
    slug: "investment-rental",
    name: "Investment & Rental",
    pageTitle: "Investment & Rental Interior Design",
    tagline: "Guest-ready. Profit-smart. Unforgettable.",
    heroImage: { base: "hero", widths: [1600, 2000], sizes: "100vw", alt: "Styled poolside lounge area, guest-ready outdoor space" },
    acts: [
      {
        label: "The Guest's Eye",
        body: "We start by seeing your property the way a guest would, what makes them book, what makes them stay, what makes them come back.",
        bullets: [
          "Walk the property, in person or virtually, and identify what needs to change",
          "Review your booking goals, target guest, and any performance or photo pain points",
          "Define the style story your listing should tell before a guest ever arrives",
        ],
        closing: "The read that shapes every styling decision that follows.",
        image: PROCESS_ACT1_TALKING,
      },
      {
        label: "Styled to Perform",
        body: "Depending on your property, this can include a full styling plan built for bookings, comfort, and durability all at once.",
        bullets: [
          "A cohesive design concept tailored to your property's style and target guest",
          "Furnishings and finishes selected to withstand turnover without sacrificing style",
          "Styling for the moments that get photographed, and the ones that get remembered",
          "Sourcing and purchasing, handled start to finish",
        ],
        closing: "Design that works as hard as your property does.",
        images: PROCESS_POSTCARDS,
      },
      {
        label: "Ready for Bookings",
        body: "A fully styled, guest-ready space, photographed and staged to turn lookers into bookers.",
        bullets: [
          "A fully furnished, guest-ready property",
          "Styling built to photograph beautifully and hold up to real turnover",
          "Care notes so the space stays exactly as booked",
        ],
        closing: "Booked for style. Remembered for feeling.",
        image: PROCESS_ACT3_LIVINGROOM,
      },
    ],
    subservices: [
      {
        name: "Visual Storytelling for Listings",
        subtitle: "Design that photographs well, feels even better.",
        body: "We consider angles, lighting, and layout to create Instagram-worthy, scroll-stopping moments that bring your rental to life online, and in real life.",
        hook: "Booked for style.",
        image: { base: "included-1", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Styled poolside lounge area, guest-ready outdoor space" },
      },
      {
        name: "Guest Centered Styling",
        subtitle: "Comfort, flow, and quiet hospitality.",
        body: "From bedding to entry console to the perfect sconce, we design with the guest experience in mind, emphasizing ease, beauty, and emotional warmth.",
        hook: "Remembered for feeling.",
        image: { base: "included-2", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Welcoming entryway, styled console and staircase" },
      },
      {
        name: "Furnishings Built to Last",
        subtitle: "Durability meets design.",
        body: "We select finishes and furnishings that withstand turnover without sacrificing style, so your property stays beautiful, and profitable.",
        hook: "Style that survives the season.",
        image: { base: "included-3", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Poolside styling detail, cushions and linens" },
      },
      {
        name: "Multi-Property & Brand Styling",
        subtitle: "Scalable design, consistent soul.",
        body: "For investors managing multiple units or building a recognizable short-term rental brand, we offer scalable design systems with a cohesive visual identity.",
        hook: "One brand, every property.",
        image: { base: "included-4", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Full property exterior, styled entrance and landscaping" },
      },
    ],
    ctaLine: "Reach Out. Feel the Return.",
  },

  // The old site (sixthsensestudio.co/new-construction-interior-design)
  // has 4 sequential process steps in place of the usual 3-act structure
  // — same shape as Investment & Rental's gap, so acts are written fresh
  // here too and the 4 steps became the subservices list unchanged.
  // Subservice images: real photos from the old site (blueprints, a
  // custom closet/built-in, a sculptural lamp) — one image from the old
  // site (a leather material swatch) was skipped on purpose, a
  // third-party vendor's brand name ("jamie stern LEATHER") was visible
  // on it, same attribution caution as the residential moodboard photo
  // earlier this project; Residential's own material-flatlay photo (no
  // brand visible) covers "Material Finish & Selection" instead. Act
  // images were originally real old-site photos too (blueprints, a
  // material flat-lay, a sculptural lamp) — replaced per explicit
  // follow-up with PROCESS_POSTCARDS (the same 3-image "postcard stack"
  // built for Virtual Design's Act 2), reused verbatim across all 3 Acts
  // here — see PROCESS_POSTCARDS's own comment above.
  "new-development": {
    slug: "new-development",
    name: "New Development",
    pageTitle: "New Development Interior Design",
    tagline: "Your vision, built from the ground up.",
    heroImage: { base: "hero", widths: [1600, 2000], sizes: "100vw", alt: "Architectural floor plans and rolled blueprints" },
    acts: [
      {
        label: "Before the First Wall",
        body: "Every home starts with a foundation, literally. We join the process early, before the first wall is framed, so every decision from there is intentional.",
        bullets: [
          "Collaborate with your builder, draftsman, and engineer to optimize flow, function, and feel",
          "Review architectural plans before the foundation is even poured",
          "Begin shaping the vision that will guide every material and finish choice ahead",
        ],
        closing: "Every detail, considered early.",
        image: PROCESS_ACT1_TALKING,
      },
      {
        label: "Chosen, Piece by Piece",
        body: "From tile and countertops to hardware and paint, we guide you through each choice with an eye for cohesion, longevity, and personal style.",
        bullets: [
          "Material, finish, and fixture selections guided start to finish",
          "Custom furnishings and built-ins designed for your lifestyle, not the catalog",
          "Coordination with your builder and trades at every stage",
        ],
        closing: "The tactile story of your home, chosen with intention.",
        images: PROCESS_POSTCARDS,
      },
      {
        label: "The Final Layer",
        body: "Window treatments, rugs, lighting, and decor, every detail adds mood, memory, and meaning.",
        bullets: [
          "A fully styled, move-in-ready home",
          "Custom pieces sourced or created for your exact space",
          "The final layer that turns a new build into a home",
        ],
        closing: "Your foundation, reimagined.",
        image: PROCESS_ACT3_LIVINGROOM,
      },
    ],
    subservices: [
      {
        name: "Pre-Construction & Floor Plan Review",
        subtitle: "Every detail, considered early.",
        body: "We collaborate with our (or your) builder, draftsman, and engineer to optimize flow, function, and feel, before the foundation is even poured.",
        hook: "The plan that everything else builds on.",
        image: { base: "included-1", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Architectural floor plans and rolled blueprints" },
      },
      {
        name: "Material Finish & Selection",
        subtitle: "The tactile story of your home.",
        body: "From tile and countertops to hardware and paint, we guide you through each choice with an eye for cohesion, longevity, and personal style.",
        hook: "Chosen once, chosen right.",
        image: { base: "included-2", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Flat-lay of material and finish samples: fabric, marble, leather, hardware" },
      },
      {
        name: "Custom Furnishings & Built-Ins",
        subtitle: "Designed for your lifestyle, not the catalog.",
        body: "We create or source pieces tailored to your space and vision, from custom closets to kitchen islands to heirloom-worthy seating.",
        hook: "Built for how you actually live.",
        image: { base: "included-3", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Custom built-in closet with lit display shelving" },
      },
      {
        name: "Styling & Final Layer",
        subtitle: "The final details that bring it to life.",
        body: "Window treatments, rugs, lighting, and decor, every detail adds mood, memory, and meaning.",
        hook: "The last layer, and the one you'll feel first.",
        image: { base: "included-4", widths: [700, 1400], sizes: "(min-width: 900px) 42vw, 100vw", alt: "Sculptural table lamp, final styling detail" },
      },
    ],
    ctaLine: "Reach Out. Feel It Take Shape.",
  },
};
